import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TStaffEligibleResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStaffEligibleUsersKey = 'get-staff-eligible-users';

export const useStaffEligibleUsersHook = (
  instituteId: string,
  search?: string,
  enabled = true
): UseQueryResult<TStaffEligibleResponse, TQueryError> => {
  const { getStaffEligibleUsers } = useUsersService();

  return useQuery<TStaffEligibleResponse, TQueryError>({
    queryKey: [getStaffEligibleUsersKey, instituteId, search],
    queryFn: () => getStaffEligibleUsers(instituteId, search),
    enabled,
  });
};
